/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/frame_patent': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _fill="none" _stroke="#000"><path pid="0" stroke-width=".5" stroke-miterlimit="23" d="M27.5 13V4.5H19M19 27.5h8.5V19M4.5 19v8.5H13M13 4.5H4.5V13"/><path pid="1" stroke-width="1.99998" stroke-miterlimit="10" d="M16 2l14 13.999-14 14-14-14z"/></g>'
  }
})
